import type { ProfileConfig } from "@worker/config-schema";
import { el } from "../lib/dom";
import { renderProfileParts } from "./parts";

/**
 * Split template — two columns on wide viewports.
 *
 *   ┌──────────────────────┬──────────────────────┐
 *   │ [AV] name · badges   │ widgets              │
 *   │ description          │ widgets              │
 *   │ socials              │ links                │
 *   │ meta (views/loc/clk) │ audio                │
 *   └──────────────────────┴──────────────────────┘
 *
 * Collapses to a single-column stack below ~780px (see CSS media query).
 */
export function renderSplit(
  config: ProfileConfig,
  options: { gateOpened: Promise<void> } = { gateOpened: Promise.resolve() },
): HTMLElement {
  const p = renderProfileParts(config, options);
  p.card.classList.add("card--split");

  const leftIdentity = el("div", { class: "card__split-identity" }, [
    p.avatar,
    el("div", { class: "card__identity" }, [
      el("div", { class: "card__name-row" }, [p.username, p.badges]),
      p.description,
    ]),
  ]);

  const left = el("div", { class: "card__split-left" }, [leftIdentity]);
  if (p.socials) left.append(p.socials);
  const metaRow = el("div", { class: "card__meta" });
  const vc = p.meta.getInline("views");    if (vc) metaRow.append(vc);
  const loc = p.meta.getInline("location"); if (loc) metaRow.append(loc);
  const clk = p.meta.getInline("clock");    if (clk) metaRow.append(clk);
  const ct = p.meta.getInline("contact");
  // Contact floats top-right in split.
  if (ct && p.contact) {
    const corner = el("div", { class: "card__corner card__corner--top-right" }, [ct]);
    p.card.append(corner);
  }
  if (metaRow.childElementCount > 0) left.append(metaRow);

  const right = el("div", { class: "card__split-right" });
  if (p.widgets) right.append(p.widgets);
  if (p.links) right.append(p.links);
  if (p.audio) right.append(p.audio);

  const top = el("div", { class: "card__split-top" }, [left, right]);
  p.card.append(top);
  p.meta.applyCornerZones();

  return p.card;
}
